export default __webpack_public_path__ + "static/media/tenSteps.f3ec37e7.PNG";